import { createAsyncAction, createAction } from './creator';

export const USER_CHECK_STATUS = 'USER_CHECK_STATUS';
export const USER_SIGN_OUT = 'USER_SIGN_OUT';
export const USER_GET_INFO = 'USER_GET_INFO';
export const USER_CREATE_CLIENT = 'USER_CREATE_CLIENT';
export const USER_UPDATE_ADMIN = 'USER_UPDATE_ADMIN';
export const USER_GET_USER_SETTING = 'USER_GET_USER_SETTING';
export const USER_SET_USER_SETTING = 'USER_SET_USER_SETTING';
export const USER_GET_CLIENT_INFO = 'USER_GET_CLIENT_INFO';
export const USER_GET_CLIENT_DETAIL = 'USER_GET_CLIENT_DETAIL';
export const USER_GET_PASSPORT_DETAIL = 'USER_GET_PASSPORT_DETAIL';
export const USER_UPDATE_CLIENT = 'USER_UPDATE_CLIENT';
export const USER_RESET_PSW = 'USER_RESET_PSW';
export const USER_GET_ROLES = 'USER_GET_ROLES';
export const USER_SET_PAGESIZE = 'USER_SET_PAGESIZE';
export const USER_SET_INFO = 'USER_SET_INFO';
export const USER_SET_STATUS = 'USER_SET_STATUS';

export const getInfo = createAsyncAction(USER_GET_INFO);
export const setInfo = createAction(USER_SET_INFO);
export const setStatus = createAction(USER_SET_STATUS);

export const checkStatus = createAsyncAction(USER_CHECK_STATUS);
export const signOut = createAsyncAction(USER_SIGN_OUT);
export const getClientInfo = createAsyncAction(USER_GET_CLIENT_INFO);
export const getClientDetail = createAsyncAction(USER_GET_CLIENT_DETAIL);
export const getPassportDetail = createAsyncAction(USER_GET_PASSPORT_DETAIL);
export const getUserSetting = createAsyncAction(USER_GET_USER_SETTING);
export const setUserSetting = createAsyncAction(USER_SET_USER_SETTING);
export const createClient = createAsyncAction(USER_CREATE_CLIENT);
export const updateAdmin = createAsyncAction(USER_UPDATE_ADMIN);
export const updateClient = createAsyncAction(USER_UPDATE_CLIENT);
export const resetPsw = createAsyncAction(USER_RESET_PSW);
export const getRoles = createAsyncAction(USER_GET_ROLES);
export const setPageSize = createAction(USER_SET_PAGESIZE);
